import { css } from "styled-components";

export const mainLayoutStyles = css`
    &.aevi-master {
        width: 100%;
        overflow: hidden;
        background-color: white;
        text-align: left;
    }
`;
